import { Component, OnInit } from '@angular/core';
import { label } from '../constants/labels';
import { message } from '../constants/messages';
import { BaseAPIService } from '@app/Services/api.base.service';
import { UtilService } from '@app/Services/util.service';
import { ITenantInfo } from '@app/Models/ITenantInfo';
import { ITenantList } from '../Models/ITenantList';
import { FiledownloadService } from '@app/Services/filedownload.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { IDropdownConfig } from '../Models/IDeviceMetadata';


@Component({
  selector: 'app-reports',
  standalone: false,
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  providers: [MessageService]

})
export class ReportsComponent implements OnInit {
  labels: any;
  messages: any;
  img: any;
  selectedType: any;
  selectedReportType: string;
  exportDrpConfig: IDropdownConfig;
  selectedDate: Date;
  tenantData: any[];
  userData: any[];
  userUnderTenantData: any[];
  tenantInfo: ITenantInfo;
  tenantDrpdwnConfig: IDropdownConfig;
  selectedTenant: any = [];
  tenantList: ITenantList[];
  isEnable: boolean = true;
  isDateEnable: boolean = true;
  reportGeneratedDt: Date = new Date();

  constructor(private readonly baseService: BaseAPIService, private readonly fileDownloadService: FiledownloadService,
    private readonly messageService: MessageService, private readonly translate: TranslateService) { }

  ngOnInit() {
    this.labels = label;
    this.messages = message;
    this.GetTenantList();
    this.selectedDate = new Date();
    this.selectedReportType = 'xlsx';
    this.selectedType = 'coolersUnderTenant';
    this.reportGeneratedDt=UtilService.FormatDate(this.reportGeneratedDt);
    this.tenantDrpdwnConfig = {
      displayKey: "tenant_name",
      search: true,
      height: '300px',
      placeholder:this.translate.instant(this.labels.select)
    }

  }

  public GenerateReport() {
    if (this.selectedType === 'registeredTenant') {
      const params = `?exportType=${this.selectedReportType}`;
      this.fileDownloadService.DownloadGet(`/Reports/GetRegisteredTenantDetails/${params}`, `RegisteredTenants.${this.reportGeneratedDt}.${this.selectedReportType}`);
    }
    else if (this.selectedType === 'registeredUser') {
      const params = `?exportType=${this.selectedReportType}`;
      this.fileDownloadService.DownloadGet(`/Reports/GetRegisteredUserDetails/${params}`, `RegisteredUsers.${this.reportGeneratedDt}.${this.selectedReportType}`);
    }
    else if (this.selectedType === 'userUnderTenant') {
      if (this.selectedTenant[0] !== undefined) {
        const params = `?TenantId=${this.selectedTenant[0].tenant_id}&exportType=${this.selectedReportType}`;
        this.fileDownloadService.DownloadGet(`/Reports/GetUsersUnderTenantDetails/${params}`, `${this.selectedTenant[0].tenant_name}UserList.${this.reportGeneratedDt}.${this.selectedReportType}`);
      }
      else {
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.selecteTanent), detail: this.translate.instant(this.messages.tenantnotSelected), key: 'error' });
      }
    }
    else if (this.selectedType === 'coolersUnderTenant') {
      if (this.selectedTenant[0] !== undefined) {
        const params = `?TenantId=${this.selectedTenant[0].tenant_id}&toDate=${encodeURI(UtilService.FormatDate(this.selectedDate).toString())}&exportType=${this.selectedReportType}`;
        this.fileDownloadService.DownloadGet(`/Reports/GetCoolersUnderTenantDetails/${params}`, `${this.selectedTenant[0].tenant_name}CoolerList.${this.reportGeneratedDt}.${this.selectedReportType}`);
      }
      else {
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.selecteTanent), detail: this.translate.instant(this.messages.tenantnotSelected), key: 'error' });
      }
    }
    else if(this.selectedType==='renewalNotify'){
      if (this.selectedTenant[0] !== undefined) {
        const params = `?TenantId=${this.selectedTenant[0].tenant_id}&exportType=${this.selectedReportType}`;
        this.fileDownloadService.DownloadGet(`/Reports/GetSentNotificationList/${params}`, `${this.selectedTenant[0].tenant_name}RenewalNotificationList.${this.reportGeneratedDt}.${this.selectedReportType}`);
      }
      else {
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.selecteTanent), detail: this.translate.instant(this.messages.tenantnotSelected), key: 'error' });
      }
    }
    else if(this.selectedType==='coolersByCountry'){
      const params = `?exportType=${this.selectedReportType}`;
      this.fileDownloadService.DownloadGet(`/Reports/GetCoolersByCountryDetails/${params}`, `CoolersByCountry.${this.reportGeneratedDt}.${this.selectedReportType}`);
    }
  }

  public GetTenantList() {
    this.baseService.GET('/Reports/GetAllTenantNames/').subscribe((result: ITenantList[]) => {
      this.tenantList = result;
    })
  }

  public changeRadio($event: any) {
    if (this.selectedType === 'userUnderTenant' || this.selectedType === 'coolersUnderTenant' || this.selectedType === 'renewalNotify') {
      this.isEnable = true;
      this.selectedTenant = [];
    }
    else {
      this.isEnable = false;
    }
    this.isDateEnable = this.selectedType === 'coolersUnderTenant';
  }
}
